import React from "react";
import "./TnC.scss";

const TermsConditions = () => {
  return (
    <div className="tc-page">
      <div className="tc-container">
        <h1 className="tc-title">Syarat & Ketentuan</h1>
        <p className="tc-subtitle">
          Harap baca syarat dan ketentuan ini dengan saksama sebelum menggunakan
          layanan kami.
        </p>

        <div className="tc-divider"></div>

        <section className="tc-section">
          <h2>Ketentuan Penggunaan Website</h2>
          <p>
            Website ini dikelola oleh mitra pemasaran independen PT Asia Rumah
            Utama untuk Summarecon Serpong. Dengan mengakses dan menggunakan
            website ini, Anda setuju untuk terikat oleh Syarat & Ketentuan ini.
          </p>
        </section>

        <section className="tc-section">
          <h2>Informasi Properti</h2>
          <p>
            Informasi, harga, spesifikasi, dan ketersediaan unit properti yang
            ditampilkan di website ini dapat berubah sewaktu-waktu tanpa
            pemberitahuan sebelumnya.
          </p>
          <p>
            Gambar, ilustrasi, dan desain yang ada pada website ini merupakan
            representasi artis dan dapat berbeda dari kondisi aktual di
            lapangan.
          </p>
        </section>

        <section className="tc-section">
          <h2>Tanggung Jawab</h2>
          <p>
            PT Asia Rumah Utama bertindak sebagai agen pemasaran independen dan
            tidak bertanggung jawab atas kerugian langsung maupun tidak langsung
            yang timbul dari penggunaan informasi di website ini. Pembeli
            disarankan untuk selalu memverifikasi informasi secara langsung
            dengan cara menghubungi kami sebelum melakukan transaksi.
          </p>
        </section>

        <section className="tc-section">
          <h2>Perubahan Syarat & Ketentuan</h2>
          <p>
            Kami berhak untuk mengubah atau memperbarui Syarat & Ketentuan ini
            kapan saja. Perubahan akan berlaku segera setelah dipublikasikan di
            halaman ini.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
